<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div>
          <label class="title">中心总览</label>
          <slot name="periodItemId2"></slot>
          注册时间：<a-range-picker v-model="registerDateRange" value-format="YYYY-MM-DD" @change="dateChange"
                               :ranges="{ '本日': [moment(), moment()], '本周': [moment().startOf('week'), moment().endOf('week')],'本月': [moment().startOf('month'), moment().endOf('month')]  }"
        />
        </div>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div style="margin-top: 10px">
      <a-table
        ref="table"

        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :scroll="tableScroll"
        :pagination="false"
        :loading="loading"
        @change="handleTableChange">

        <span slot="action" slot-scope="text, record">
          <a v-if="record.centerid" @click="handleInfoView(record)">中心明细</a>
        </span>
      </a-table>
    </div>

  </a-card>
</template>

<script>
  import moment from 'moment';
  import {putAction,getFileAccessHttpUrl} from '@/api/manage';
  import {frozenBatch} from '@/api/api'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import {CACHE_PROJECT_ID} from '@/constants/project'
  import { getAction,postAction } from '@/api/manage'

  import Vue from 'vue'
  export default {
    name: "Center",
    mixins: [JeecgListMixin],
    components: {

    },
    props:['periodItemId'],
    data() {
      return {
        registerDateRange:[],
        projectId: Vue.ls.get(CACHE_PROJECT_ID),
        description: '这是用户管理页面',
        queryParam: {},
        centerName:'',
        columns:[],
        tableScroll:{x:400},
        url: {
          list: "/project/statistic/baseLine/center",
        },
        disableMixinCreated:true,
      }
    },
    computed: {

    },
    watch:{
      periodItemId(){
        this.queryParam.periodItemId = this.periodItemId
        this.loadData()
      }
    },
    mounted(){
      this.queryParam = {
        periodItemId:this.periodItemId,
        projectId:this.projectId
      }
      this.loadData()
    },
    methods: {
      loadDataCallback(){
        const columns = [
          {
            title: '研究中心',
            align: "center",
            dataIndex: 'centername',
            fixed:'left',
            width: 200,
          },
          {
            title: '入组人数',
            align: "center",
            fixed:'left',
            width: 100,
            dataIndex: 'patientnum',
          },
        ]
        // 处理动态表头
       if(this.dataSource.length>0){
         const data = this.dataSource[0]
         // 处理第一级表头
         for (let key in data){
           if(key=='centerid' || key=='centername' || key=='patientnum'){
             continue
           }
           // 动态表头
           if(key.endsWith("formname")){
             const parentColumn = {
               title: data[key],
               align: "center",
               children:[]
             }
             //
             const formid = key.replace("formname","")
             parentColumn.children.push({
               title: '正常提交总数(占比)',
               align: "center",
               width: 160,
               customRender:(text,row,index)=>{
                 return `${row[formid+"normalsubmit"]}(${row[formid+"normalsubmitrate"]}%)`
               }
             })
             parentColumn.children.push({
               title: '完整提交总数(占比)',
               align: "center",
               width: 160,
               customRender:(text,row,index)=>{
                 return `${row[formid+"fullsubmit"]}(${row[formid+"fullsubmitrate"]}%)`
               }
             })
             columns.push(parentColumn)
           }
         }
       }
       columns.push( {
         title: '操作',
         align: "center",
         fixed:'right',
         width: 100,
         scopedSlots: {customRender: 'action'},
       })
        this.columns = columns
      },
      moment,
      dateChange(){
        if(this.registerDateRange.length===0){
          this.queryParam.startDate = ''
          this.queryParam.endDate = ''
        }else {
          this.queryParam.startDate = this.registerDateRange[0]
          this.queryParam.endDate = this.registerDateRange[1]
        }
        this.loadData()
      },
      handleInfoView(record){
        this.$emit('change',record.centerid)
      }
    }
  }
</script>
<style scoped lang="less">
  .title{
    font-size: 20px;
    font-weight: bold;
    color: @primary-color;
    margin-right: 30px;
  }
</style>
